export const TRUNCATE_BY = {
  WORD: 'word',
  CHAR: 'char'
}

export function stripHtml (html) {
  if (!html) return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

function countWords (text) {
  if (!text) return 0
  return text.trim().split(/\s+/).filter(Boolean).length
}

function shouldKeepEmptyElement (node) {
  if (!node || node.nodeType !== Node.ELEMENT_NODE) return false
  const keepTags = ['BR', 'HR', 'IMG', 'SOURCE', 'TRACK', 'WBR']
  return keepTags.includes(node.tagName)
}

export function shouldTruncateHtml (html, limit, options = {}) {
  if (!html) return false
  const { by = TRUNCATE_BY.WORD } = options
  const textContent = stripHtml(html)
  if (by === TRUNCATE_BY.CHAR) {
    return textContent.length > limit
  }
  return countWords(textContent) > limit
}

export function truncateHtml (html, limit, options = {}) {
  if (!html) return ''
  const { by = TRUNCATE_BY.WORD } = options
  const container = document.createElement('div')
  container.innerHTML = html
  const result = document.createElement('div')
  let remaining = limit

  const appendWhitespaceOnly = (text, parent) => {
    if (parent.childNodes.length > 0) {
      parent.appendChild(document.createTextNode(text))
    }
  }

  const appendTextNode = (text, parent) => {
    if (!text) return
    if (by === TRUNCATE_BY.WORD) {
      const matches = [...text.matchAll(/\S+/g)]
      if (matches.length === 0) {
        appendWhitespaceOnly(text, parent)
        return
      }

      if (matches.length <= remaining) {
        parent.appendChild(document.createTextNode(text))
        remaining -= matches.length
        return
      }

      if (remaining > 0) {
        const lastAllowed = matches[remaining - 1]
        const cutoff = lastAllowed.index + lastAllowed[0].length
        const truncated = text.slice(0, cutoff).replace(/\s+$/, '') + '...'
        parent.appendChild(document.createTextNode(truncated))
      }
      remaining = 0
      return
    }

    if (!text.trim()) {
      appendWhitespaceOnly(text, parent)
      return
    }

    const length = text.length
    if (length <= remaining) {
      parent.appendChild(document.createTextNode(text))
      remaining -= length
      return
    }

    if (remaining > 0) {
      const truncated = text.slice(0, remaining).replace(/\s+$/, '') + '...'
      parent.appendChild(document.createTextNode(truncated))
    }
    remaining = 0
  }

  const processNode = (node, parent) => {
    if (remaining <= 0) {
      return
    }

    if (node.nodeType === Node.TEXT_NODE) {
      appendTextNode(node.textContent || '', parent)
      return
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false)
      const children = Array.from(node.childNodes)
      for (const child of children) {
        if (remaining <= 0) break
        processNode(child, clone)
      }

      if (clone.childNodes.length > 0 || shouldKeepEmptyElement(node)) {
        parent.appendChild(clone)
      }
      return
    }

    if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const children = Array.from(node.childNodes)
      for (const child of children) {
        if (remaining <= 0) break
        processNode(child, parent)
      }
    }
  }

  const topLevelNodes = Array.from(container.childNodes)
  for (const node of topLevelNodes) {
    if (remaining <= 0) break
    processNode(node, result)
  }

  return result.innerHTML
}
